// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DevelopmentCommitmentPotentialLineItemFragmentDoc } from './DevelopmentCommitmentPotentialLineItem.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CreateCommitmentDataProject_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, name: string, market: { __typename?: 'Market', id: string }, cohort?: { __typename?: 'Cohort', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, development?: { __typename?: 'Development', id: string } | null | undefined } | null | undefined };

export type CreateCommitmentDataProject_Region_Fragment = { __typename?: 'Region', id: string, name: string, market?: { __typename?: 'Market', id: string } | null | undefined, cohort?: { __typename?: 'Cohort', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, development?: { __typename?: 'Development', id: string } | null | undefined } | null | undefined };

export type CreateCommitmentDataProject_Market_Fragment = { __typename?: 'Market', id: string, name: string, market: { __typename?: 'Market', id: string }, cohort?: { __typename?: 'Cohort', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, development?: { __typename?: 'Development', id: string } | null | undefined } | null | undefined };

export type CreateCommitmentDataProject_Community_Fragment = { __typename?: 'Community', id: string, name: string, market: { __typename?: 'Market', id: string }, cohort?: { __typename?: 'Cohort', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, development?: { __typename?: 'Development', id: string } | null | undefined } | null | undefined };

export type CreateCommitmentDataProject_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, name: string, market: { __typename?: 'Market', id: string }, cohort?: { __typename?: 'Cohort', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, development?: { __typename?: 'Development', id: string } | null | undefined } | null | undefined };

export type CreateCommitmentDataProject_Lot_Fragment = { __typename?: 'Lot', id: string, name: string, market: { __typename?: 'Market', id: string }, cohort?: { __typename?: 'Cohort', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, development?: { __typename?: 'Development', id: string } | null | undefined } | null | undefined };

export type CreateCommitmentDataProject_Structure_Fragment = { __typename?: 'Structure', id: string, name: string, market: { __typename?: 'Market', id: string }, cohort?: { __typename?: 'Cohort', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, development?: { __typename?: 'Development', id: string } | null | undefined } | null | undefined };

export type CreateCommitmentDataProject_Unit_Fragment = { __typename?: 'Unit', id: string, name: string, market: { __typename?: 'Market', id: string }, cohort?: { __typename?: 'Cohort', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, development?: { __typename?: 'Development', id: string } | null | undefined } | null | undefined };

export type CreateCommitmentDataProjectFragment =
  | CreateCommitmentDataProject_StandaloneProject_Fragment
  | CreateCommitmentDataProject_Region_Fragment
  | CreateCommitmentDataProject_Market_Fragment
  | CreateCommitmentDataProject_Community_Fragment
  | CreateCommitmentDataProject_Subdivision_Fragment
  | CreateCommitmentDataProject_Lot_Fragment
  | CreateCommitmentDataProject_Structure_Fragment
  | CreateCommitmentDataProject_Unit_Fragment
;

export type CreateCommitmentDataDevelopmentFragment = { __typename?: 'Development', id: string, name: string };

export type CreateCommitmentDataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CreateCommitmentDataQuery = { __typename?: 'Query', tradePartners: Array<{ __typename?: 'TradePartner', id: string, name: string }>, stages: Array<{ __typename?: 'StageDetail', code: Types.Stage, name: string }>, projects: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string, market: { __typename?: 'Market', id: string }, cohort?: { __typename?: 'Cohort', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, development?: { __typename?: 'Development', id: string } | null | undefined } | null | undefined }
    | { __typename?: 'Region', id: string, name: string, market?: { __typename?: 'Market', id: string } | null | undefined, cohort?: { __typename?: 'Cohort', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, development?: { __typename?: 'Development', id: string } | null | undefined } | null | undefined }
    | { __typename?: 'Market', id: string, name: string, market: { __typename?: 'Market', id: string }, cohort?: { __typename?: 'Cohort', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, development?: { __typename?: 'Development', id: string } | null | undefined } | null | undefined }
    | { __typename?: 'Community', id: string, name: string, market: { __typename?: 'Market', id: string }, cohort?: { __typename?: 'Cohort', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, development?: { __typename?: 'Development', id: string } | null | undefined } | null | undefined }
    | { __typename?: 'Subdivision', id: string, name: string, market: { __typename?: 'Market', id: string }, cohort?: { __typename?: 'Cohort', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, development?: { __typename?: 'Development', id: string } | null | undefined } | null | undefined }
    | { __typename?: 'Lot', id: string, name: string, market: { __typename?: 'Market', id: string }, cohort?: { __typename?: 'Cohort', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, development?: { __typename?: 'Development', id: string } | null | undefined } | null | undefined }
    | { __typename?: 'Structure', id: string, name: string, market: { __typename?: 'Market', id: string }, cohort?: { __typename?: 'Cohort', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, development?: { __typename?: 'Development', id: string } | null | undefined } | null | undefined }
    | { __typename?: 'Unit', id: string, name: string, market: { __typename?: 'Market', id: string }, cohort?: { __typename?: 'Cohort', id: string, name: string, market: { __typename?: 'Market', id: string, name: string }, development?: { __typename?: 'Development', id: string } | null | undefined } | null | undefined }
  >, developments: Array<{ __typename?: 'Development', id: string, name: string }> };

export type CreateCommitmentPotentialLineItemsQueryVariables = Types.Exact<{
  projectIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  stage?: Types.InputMaybe<Types.Stage>;
}>;


export type CreateCommitmentPotentialLineItemsQuery = { __typename?: 'Query', developmentCommitmentPotentialLineItems: Array<{ __typename?: 'DevelopmentCommitmentPotentialLineItem', costType: Types.CostType, totalCostInCents: number, projects: Array<string>, item: { __typename?: 'Item', displayName: string, id: string, costCode: { __typename?: 'CostCode', displayName: string, id: string } }, location: { __typename?: 'Location', id: string, name: string } }> };

export type CreateDevelopmentCommitmentMutationVariables = Types.Exact<{
  input: Types.SaveDevelopmentCommitmentInput;
}>;


export type CreateDevelopmentCommitmentMutation = { __typename?: 'Mutation', saveDevelopmentCommitment: { __typename?: 'SaveDevelopmentCommitmentResult', developmentCommitment: { __typename?: 'DevelopmentCommitment', id: string } } };

export const CreateCommitmentDataProjectFragmentDoc = gql`
    fragment CreateCommitmentDataProject on Project {
  id
  market {
    id
  }
  name
  cohort {
    id
    name
    market {
      id
      name
    }
    development {
      id
    }
  }
}
    `;
export const CreateCommitmentDataDevelopmentFragmentDoc = gql`
    fragment CreateCommitmentDataDevelopment on Development {
  id
  name
}
    `;
export const CreateCommitmentDataDocument = gql`
    query CreateCommitmentData {
  tradePartners {
    id
    name
  }
  stages {
    code
    name
  }
  projects(filter: {status: [ACTIVE, COMPLETED, HOLD]}) {
    ...CreateCommitmentDataProject
  }
  developments(filter: {}) {
    ...CreateCommitmentDataDevelopment
  }
}
    ${CreateCommitmentDataProjectFragmentDoc}
${CreateCommitmentDataDevelopmentFragmentDoc}`;

/**
 * __useCreateCommitmentDataQuery__
 *
 * To run a query within a React component, call `useCreateCommitmentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateCommitmentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateCommitmentDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateCommitmentDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CreateCommitmentDataQuery, CreateCommitmentDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CreateCommitmentDataQuery, CreateCommitmentDataQueryVariables>(CreateCommitmentDataDocument, options);
      }
export function useCreateCommitmentDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreateCommitmentDataQuery, CreateCommitmentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CreateCommitmentDataQuery, CreateCommitmentDataQueryVariables>(CreateCommitmentDataDocument, options);
        }
// @ts-ignore
export function useCreateCommitmentDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CreateCommitmentDataQuery, CreateCommitmentDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CreateCommitmentDataQuery, CreateCommitmentDataQueryVariables>;
export function useCreateCommitmentDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreateCommitmentDataQuery, CreateCommitmentDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CreateCommitmentDataQuery | undefined, CreateCommitmentDataQueryVariables>;
export function useCreateCommitmentDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreateCommitmentDataQuery, CreateCommitmentDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CreateCommitmentDataQuery, CreateCommitmentDataQueryVariables>(CreateCommitmentDataDocument, options);
        }
export type CreateCommitmentDataQueryHookResult = ReturnType<typeof useCreateCommitmentDataQuery>;
export type CreateCommitmentDataLazyQueryHookResult = ReturnType<typeof useCreateCommitmentDataLazyQuery>;
export type CreateCommitmentDataSuspenseQueryHookResult = ReturnType<typeof useCreateCommitmentDataSuspenseQuery>;
export type CreateCommitmentDataQueryResult = ApolloReactCommon.QueryResult<CreateCommitmentDataQuery, CreateCommitmentDataQueryVariables>;
export const CreateCommitmentPotentialLineItemsDocument = gql`
    query CreateCommitmentPotentialLineItems($projectIds: [ID!]!, $stage: Stage) {
  developmentCommitmentPotentialLineItems(projectIds: $projectIds, stage: $stage) {
    ...DevelopmentCommitmentPotentialLineItem
  }
}
    ${DevelopmentCommitmentPotentialLineItemFragmentDoc}`;

/**
 * __useCreateCommitmentPotentialLineItemsQuery__
 *
 * To run a query within a React component, call `useCreateCommitmentPotentialLineItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateCommitmentPotentialLineItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateCommitmentPotentialLineItemsQuery({
 *   variables: {
 *      projectIds: // value for 'projectIds'
 *      stage: // value for 'stage'
 *   },
 * });
 */
export function useCreateCommitmentPotentialLineItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CreateCommitmentPotentialLineItemsQuery, CreateCommitmentPotentialLineItemsQueryVariables> & ({ variables: CreateCommitmentPotentialLineItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CreateCommitmentPotentialLineItemsQuery, CreateCommitmentPotentialLineItemsQueryVariables>(CreateCommitmentPotentialLineItemsDocument, options);
      }
export function useCreateCommitmentPotentialLineItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreateCommitmentPotentialLineItemsQuery, CreateCommitmentPotentialLineItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CreateCommitmentPotentialLineItemsQuery, CreateCommitmentPotentialLineItemsQueryVariables>(CreateCommitmentPotentialLineItemsDocument, options);
        }
// @ts-ignore
export function useCreateCommitmentPotentialLineItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CreateCommitmentPotentialLineItemsQuery, CreateCommitmentPotentialLineItemsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CreateCommitmentPotentialLineItemsQuery, CreateCommitmentPotentialLineItemsQueryVariables>;
export function useCreateCommitmentPotentialLineItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreateCommitmentPotentialLineItemsQuery, CreateCommitmentPotentialLineItemsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CreateCommitmentPotentialLineItemsQuery | undefined, CreateCommitmentPotentialLineItemsQueryVariables>;
export function useCreateCommitmentPotentialLineItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreateCommitmentPotentialLineItemsQuery, CreateCommitmentPotentialLineItemsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CreateCommitmentPotentialLineItemsQuery, CreateCommitmentPotentialLineItemsQueryVariables>(CreateCommitmentPotentialLineItemsDocument, options);
        }
export type CreateCommitmentPotentialLineItemsQueryHookResult = ReturnType<typeof useCreateCommitmentPotentialLineItemsQuery>;
export type CreateCommitmentPotentialLineItemsLazyQueryHookResult = ReturnType<typeof useCreateCommitmentPotentialLineItemsLazyQuery>;
export type CreateCommitmentPotentialLineItemsSuspenseQueryHookResult = ReturnType<typeof useCreateCommitmentPotentialLineItemsSuspenseQuery>;
export type CreateCommitmentPotentialLineItemsQueryResult = ApolloReactCommon.QueryResult<CreateCommitmentPotentialLineItemsQuery, CreateCommitmentPotentialLineItemsQueryVariables>;
export const CreateDevelopmentCommitmentDocument = gql`
    mutation CreateDevelopmentCommitment($input: SaveDevelopmentCommitmentInput!) {
  saveDevelopmentCommitment(input: $input) {
    developmentCommitment {
      id
    }
  }
}
    `;

/**
 * __useCreateDevelopmentCommitmentMutation__
 *
 * To run a mutation, you first call `useCreateDevelopmentCommitmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDevelopmentCommitmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDevelopmentCommitmentMutation, { data, loading, error }] = useCreateDevelopmentCommitmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDevelopmentCommitmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDevelopmentCommitmentMutation, CreateDevelopmentCommitmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateDevelopmentCommitmentMutation, CreateDevelopmentCommitmentMutationVariables>(CreateDevelopmentCommitmentDocument, options);
      }
export type CreateDevelopmentCommitmentMutationHookResult = ReturnType<typeof useCreateDevelopmentCommitmentMutation>;
export type CreateDevelopmentCommitmentMutationResult = ApolloReactCommon.MutationResult<CreateDevelopmentCommitmentMutation>;